import styled from "styled-components"

const SvgDiagram = styled.div`
  content: "";
    display: ${props => (props.Diagram ? "inline-block" : "none")};
    mask: url(${props => props.Diagram || ""}) no-repeat center;
    mask-size: contain;
    height: 20vh;
    width: calc(100% - var(--safety-padding) * 2);
    max-height: min(12rem, calc(100vw / 2));
    /* max-width: min(8rem, calc(100vw / 4));; */
    background-color: var(--color-theme-accent);
    /* margin-bottom: 1rem; */
    padding-top: 2rem;
    padding-bottom: 2rem;
`

export default SvgDiagram